import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "table table-bordered" }

import { computed, watch, onMounted, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import FileUploader from "@Blobs/Components/FileUploader.vue"
    import { Refresh } from '@browser/Browser'
    import { generateName } from '@common/Common'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'

    import { useSpreadsheetImportMappingQueryV1 } from '@Quest/Portfolios/queries-vue-composables'
    import { useImportProjectPlansFromSpreadsheetCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    import type { ProjectPlansSpreadsheetImportMappingReadModel } from '@Quest/Portfolios/readmodels'

    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ImportProjectPlansPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    // ======================
    // Query
    // ======================

    const {
        runSpreadsheetImportMappingQueryV1,
        modelSpreadsheetImportMappingQueryV1
    } = useSpreadsheetImportMappingQueryV1(workspaceId, tchProjectId)

    const rm = modelSpreadsheetImportMappingQueryV1 as Ref<ProjectPlansSpreadsheetImportMappingReadModel | null>
    const portfolioId = computed<string | null>(() => rm.value?.PortfolioId ?? null)

    const file = ref<File | null>(null)

    // ======================
    // Command
    // ======================

    const {
        invokeImportProjectPlansFromSpreadsheetCommandV1,
        succeedImportProjectPlansFromSpreadsheetCommandV1
    } = useImportProjectPlansFromSpreadsheetCommandV1(workspaceId, portfolioId)

    // ======================
    // Methods
    // ======================

    function loadMappings(blobId: string)
    {
        runSpreadsheetImportMappingQueryV1({ BlobId: blobId })
    }

    function cancelImport()
    {
        rm.value = null
    }

    function handleImportProjectPlansFromSpreadsheetCommand()
    {
        if (!rm.value) return

        invokeImportProjectPlansFromSpreadsheetCommandV1({
            BlobId: rm.value.BlobId,
            ImportedPlanName: generateName("Imported plan")
        })
    }

    // ======================
    // Watchers
    // ======================

    watch(succeedImportProjectPlansFromSpreadsheetCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            Refresh()
        }
    })

    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Import | TransparentChoice"
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"row\"><div class=\"col-lg-6\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin:0;\">Import</h1></div><div class=\"col-lg-6 text-right align-self-end\"><!--&lt;button role=&quot;button&quot; class=&quot;btn btn-outline-secondary&quot; style=&quot;padding: 0.7em 2em;&quot; @click=&quot;&quot;&gt;Add projects&lt;/button&gt;--></div></div><hr style=\"border-color:#bbb;margin:20px 0 60px;\">", 2)),
      (!_unref(rm))
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createVNode(FileUploader, {
              onSelected: _cache[0] || (_cache[0] = ($event: any) => (file.value=$event)),
              onUnselected: _cache[1] || (_cache[1] = ($event: any) => (file.value=null)),
              onUploaded: loadMappings
            })
          ]))
        : _createCommentVNode("v-if", true),
      (_unref(rm))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-secondary mr-1",
              onClick: handleImportProjectPlansFromSpreadsheetCommand
            }, "Import"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: cancelImport
            }, "Cancel"),
            _createElementVNode("table", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Sheet index"),
                  _createElementVNode("th", null, "Sheet name"),
                  _createElementVNode("th", null, "Project name"),
                  _createElementVNode("th", null, "Timeline"),
                  _createElementVNode("th", null, "Capex")
                ])
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Sheets, (s) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: s.SheetIndex
                }, [
                  _createElementVNode("td", null, _toDisplayString(s.SheetIndex), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(s.SheetName), 1 /* TEXT */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-success': s.ProjectExists, 'table-danger': !s.ProjectExists})
                  }, _toDisplayString(s.ProjectName), 3 /* TEXT, CLASS */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-success': s.Timeline, 'table-danger': !s.Timeline})
                  }, null, 2 /* CLASS */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-success': s.Capex, 'table-danger': !s.Capex})
                  }, null, 2 /* CLASS */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})